import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

const getAllOrderList = (queryParams) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.GET_ALL_ORDERS +
        queryParams,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const addBulkOrders = (formData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.UPLOAD_ORDERS,
      "POST",
      {
        // "Content-Type": "application/x-www-form-urlencoded",
      },
      formData
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getOrderById = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.GET_ORDER_BY_ID +
        `/${id}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const updateOrderById = (id, orderPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.UPDATE_ORDERS + id,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      orderPayload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const PayOrder = (id, paymentMethod = 'wallet') => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.PAY_ORDER + "/" + id + `?paymentMethod=${paymentMethod}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const CancelOrder = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.CANCEL_ORDER + "/" + id,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const addOrder = (orderPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADD_ORDER,
      "POST",
      {
        "Content-Type": "application/json",
      },
      orderPayload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getOrderDetailsByImporterr = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.GET_ORDER_DETAILS_UPID +
        `/${id}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getOrderDetailsByUpsaleo = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.GET_ORDER_DETAILS_UPID +
        `/${id}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const raiseTicket = (id, payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.RAISE_TICKET +
        `/${id}/order`,
      "POST",
      {
        "Content-Type": "application/json",
      },
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getAbnormalOrders = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ABNORMAL_ORDER,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const exportAllOrders = (queryParams = "") => {
  return new Promise(async (resolve, reject) => {
    try {
      // Get auth token from localStorage
      const { getAuthLocalStorage } = await import("../../storage/localStorage");
      const loginHeader = await getAuthLocalStorage().loginHeader;
      
      if (!loginHeader) {
        reject(new Error("No authentication token found"));
        return;
      }

      // Use fetch directly for binary data with proper auth header
      const response = await fetch(process.env.REACT_APP_APIUrl + NetworkConfiguration.EXPORT_ALL_ORDERS + queryParams, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${loginHeader}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        resolve({
          status: 200,
          data: blob,
        });
      } else {
        // Handle error response
        const errorText = await response.text();
        let errorData;
        try {
          errorData = JSON.parse(errorText);
        } catch {
          errorData = { message: errorText };
        }
        
        reject({
          status: response.status,
          error: errorData
        });
      }
    } catch (err) {
      reject(err);
    }
  });
};

const makeBulkPayment = (paymentData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.BULK_PAY_ORDERS,
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(paymentData)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const cancelBulkOrders = (cancelData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.BULK_CANCEL_ORDERS,
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(cancelData)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const raiseBulkTicket = (ticketData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.BULK_RAISE_TICKET,
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(ticketData)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const verifyRazorpayPayment = (paymentData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.VERIFY_RAZORPAY_ORDER,
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(paymentData)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getFailedOrders = (queryParams = "") => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_FAILED_ORDERS + queryParams,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getAmazonProductByAsin = (asin) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_AMAZON_PRODUCT + `/${asin}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const orderApiService = {
  getAllOrderList,
  addBulkOrders,
  getOrderById,
  updateOrderById,
  PayOrder,
  CancelOrder,
  addOrder,
  getOrderDetailsByImporterr,
  getOrderDetailsByUpsaleo,
  raiseTicket,
  getAbnormalOrders,
  getFailedOrders,
  getAmazonProductByAsin,
  exportAllOrders,
  makeBulkPayment,
  cancelBulkOrders,
  raiseBulkTicket,
  verifyRazorpayPayment,
};
